"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventBus = (function () {
    function EventBus() {
    }
    EventBus.prototype.listen = function (event, listener) {
        this.deafen(event, listener);
        EventBus.listeners[event].push(listener);
        return this;
    };
    EventBus.prototype.deafen = function (event, listener) {
        var list = EventBus.listeners[event] || [];
        var index = list.length;
        while (index--) {
            if (list[index] === listener) {
                list.splice(index, 1);
            }
        }
        EventBus.listeners[event] = list;
        return this;
    };
    EventBus.prototype.notify = function (event) {
        var extraArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraArgs[_i - 1] = arguments[_i];
        }
        var list = (EventBus.listeners[event] || []).concat();
        var size = list.length;
        var listener, index = 0;
        var newArgs = __spreadArrays([new EventBusEvent(event)], extraArgs);
        for (; index < size; index++) {
            listener = list[index];
            if (typeof listener == 'function') {
                listener.apply(null, newArgs);
            }
            else if ('handleEvent' in listener
                && typeof listener.handleEvent == 'function') {
                listener.handleEvent.apply(listener, newArgs);
            }
        }
        return this;
    };
    EventBus.listeners = {};
    return EventBus;
}());
exports.EventBus = EventBus;
var EventBusEvent = (function () {
    function EventBusEvent(type) {
        if (typeof type != 'string') {
            throw new TypeError();
        }
        this.type = type;
    }
    return EventBusEvent;
}());
exports.EventBusEvent = EventBusEvent;
